<template>
  <v-app>
    <v-main class="white d-flex justify-center align-center">
      <v-container fluid class="d-flex justify-center align-center">
        <v-sheet color="white" height="70vh" class="rounded-lg">
          <div class="text-center">
            <v-avatar color="#FDE1D6" class="mt-10" size="70">
              <v-icon dark color="primary" large> mdi-check </v-icon>
            </v-avatar>
            <br />
            <div class="text-title-2 font-weight-bold text-center pa-5">
              Your information has been shared with <br />{{
                businessProfile.businessName
              }}
            </div>

            <!-- <div class="text-subtitle-1 grey--text text-center pa-5">
              Connect with {{ businessProfile.businessName }} on the Pappyon app
              to stay updated and connected!
            </div> -->

            <v-btn
              width="85vw"
              depressed
              large
              class="primary"
              @click="handleOpenPappyonApp"
            >
              Connect on Pappyon app
            </v-btn>

            <v-btn
              text
              width="85vw"
              color="primary"
              @click="handleClose"
              depressed
              hidden
              large
            >
              Not now
            </v-btn>
          </div>
        </v-sheet>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TextFieldTitle from "@/components/TextFieldTitle";

import Registrant from "@/models/Registrant.js";
import AvatarButton from "@/components/AvatarButton";
import {getBusinessProfilesDoc, getYourBusinessNetworkDoc, updateYourBusinessNetworkDoc} from "@/shared/firebase_utils";
let uuid = require("uuid");

export default {
  async created() {
    this.businessNetworkId = this.$route.params.id;
    let bNDocRef = await getYourBusinessNetworkDoc(this.businessNetworkId);

    if (bNDocRef.exists) {
      this.businessNetwork = bNDocRef.data();
      this.registrants = this.businessNetwork.registrants;
      this.businessProfileId = this.businessNetwork.businessProfileId;
    }

    let bPDocRef = await getBusinessProfilesDoc(this.businessProfileId);

    if (bPDocRef.exists) {
      this.businessProfile = bPDocRef.data();
    }

    console.log(this.newRegistrant);
  },
  components: {
    TextFieldTitle,
    AvatarButton,
  },
  data() {
    return {
      businessProfileId: "",
      businessProfile: {},
      newRegistrant: {},
      registrants: [],
      businessNetwork: {},
      requiredRules: [(v) => !!v || "This field is required"],
      limitRules: [
        (v) =>
          (v || "").length <= 200 ||
          "Description must be 200 characters or less",
      ],
      isFormValid: false,
      sheet: false,
    };
  },
  computed: {
    ...mapGetters(["privacyPolicyUrl"]),
  },
  methods: {
    async handleSubmit() {
      try {
        if (this.$refs.registrantForm.validate()) {
          this.newRegistrant.id = uuid.v1();
          this.newRegistrant.created = new Date().toISOString();

          this.registrants.push(this.newRegistrant);
            await updateYourBusinessNetworkDoc(this.businessNetworkId,
                {
              registrants: this.registrants,
            });
          this.sheet = true;
        } else {
          console.log("form is invalid");
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleClose() {
      this.sheet = false;
      this.clearForm();
    },
    clearForm() {
      this.newRegistrant = {};
    },
    handleOpenPappyonApp() {
      window.open("https://card.pappyon.com/eTUwyDANusKm7KMV8");
    },
  },
};
</script>

<style>
</style>